<!-- 关于我们 -->
<template>

    <div class="joinbox">
        <div class="banxin">
             <div class="logobtns">
             <h1 class="logo"></h1> 
             <!-- <button class="regbtn"  @click="goRecharge()">Recharge</button>  -->
            </div>
           <div class="boxminiright" id="div_about_4" >
              <font style=" font-size: .13rem" color="#303030" ><b>Mango Live Broadcasters Violation Regulation</b></font>
            <br>
            <font color="#303030" >
            <ol start="1" type="1">
                <li class="li">Definition of the Broadcaster Violation Type:
                    <ol start="a" type="a">
                        <li> Basic Code:</li>
                        <li> Mango Live broadcaster must comply with the following provisions, otherwise, you will be punished. Mango Live Official will conduct a comprehensive assessment and the level of the violation based on the situation:</li>
                    </ol>
                </li>
                
                <b style="color:#EF493C">Serious violations (permanently close live rooms)</b>
                <li class="li">
                    <ol start="1" type="1">
                        <li> It is strictly forbidden to conduct anti-Party anti-government or insults and defamation of the country, including but not limited to:
                            <ol start="(1)" type="(1)">
                                <li>against the basic principles established by the Constitution;</li>
                                <li>endangering national unity, sovereignty, and territorial integrity;</li>
                                <li>leaking state secrets, endangering national security or jeopardizing national honors and interests;</li>
                                <li>inciting national hatred, ethnic discrimination, undermining national unity, or infringing on national customs and habits;</li>
                                <li>promoting cults and superstitions;</li>
                                <li>disrupting social order and undermining social stability;</li>
                                <li>to promote obscenity, gambling, violence or abetment;</li>
                                <li>insulting or slandering others and infringing upon the lawful rights and interests of others;</li>
                                <li>endangering social morality or national outstanding cultural traditions;</li>
                                <li>other contents prohibited by laws, administrative regulations and state regulations;</li>
                            </ol>
                        </li>
                        
                        <li> It is strictly forbidden to broadcast the content of violation of national laws and regulations, including but not limited to:
                            <ol start="(1)" type="(1)">
                                <li>It is forbidden to broadcast any activities related to gambling or suspected gambling, directly or indirectly promote gambling, and gather gambling in the live broadcast; including the following but not limited:
                                <ol start="a" type="a">
                                    <li>to make a bet on valuable items to make a bet or win;</li>
                                    <li>to use the excel probability draw to involve gambling;</li>
                                    <li>to perform a purely entertaining chess game, which needs to be reported to the platform for approval and then broadcast live;</li>
                                </ol>
                                </li>
                                <li>Promote drugs directly or indirectly, and use drugs in live broadcasts;</li>
                                <li>Low-profile pornography, such as: playing AV, playing dew point content, browsing or distributing pornographic images, selling pornographic web resources, live pornography, pornographic speech, live broadcast teaching, or indirect guidance to viewers;</li>
                                <li>It is forbidden to broadcast and promote any contents that are pornographic, violent, bloody, passive, and suspected of being edged;</li>
                                <li>Publish anti-government remarks or make insults and defamation of the state;</li>
                                <li>Remarks concerning child sexual assault, inducing criminal teaching speeches, and legally- accountable speeches;</li>
                                <li>Publish content that insults the image, name, reputation, and honor of the hero;</li>
                                <li>Expressing extreme statements;</li>
                                <li>The content of the live broadcast involves politically sensitive topics such as excessive sexual suggestion, violence, spoof classics, and distorted history;</li>
                                <li>ridicule natural disasters and major accidents;</li>
                            </ol>
                        </li>
                        <li> It is strictly forbidden to broadcast contents that threaten life safety and health, or use guns and knives to perform, including but not limited to:
                        <ol start="(1)" type="(1)">
                        <li>Display gun control tools for high-risk performances, such as: shaking control tools, guns, high-firing guns, performing highly dangerous programs, etc.;</li>
                        <li>Performing content that endangers the personal safety of others, such as: beating others, threatening others with tools, involving gangsters, and violent, etc.;</li>
                        <li>Performing programs that endanger their safety, such as suicide, self-harm, etc.;</li>
    
                        </ol>
                        </li>
                        <li>It is forbidden to destroy or damage the platform image in any way, infringe on the legitimate rights and interests of the platform, and directly or indirectly defraud the fans' money through live broadcast and offline, and have conclusive evidence;</li>
                        <b style="color:#EF493C">General Violations (warn, remove, or block the live room according to the Regulation; if the circumstances are serious, the live room will be permanently closed):</b>
                        <li> It is forbidden to broadcast all content without copyright:
                        <ol start="(1)" type="(1)">
                        <li>It is forbidden to broadcast-related content of sports games that are not copyrighted;</li>
                        <li>It is forbidden to play the content that the copyright owner declares to prohibit the rebroadcast;</li>
                        <li>It is forbidden to broadcast large-scale activities in the country;</li>
                        <li>It is forbidden to broadcast live video that infringes other video rights;</li>
    
                        </ol>
                        </li>
                        
                        <li> Disrupt the order of the platform and hinder the normal operation of the platform:
                        <ol start="(1)" type="(1)">
                        <li>It is forbidden to buy fake fans and popularity;</li>
                        <li>It is forbidden to publish false information, and it is forbidden to borrow money from others utilizing Mango Live platform (live, announcement, barrage, etc.) and ask for passwords or other information related to property;</li>
                        <li>It is forbidden to promote links to other live broadcast platforms;</li>
                        <li>The broadcaster shall not violate the qualifications of the lucky draw and modify and formulate the rules;</li>
                        <li>Deliberately fraudulent or cheating on interactive data;</li>
    
    
                        </ol>
                        </li>
                        
                        <li> It is strictly forbidden to perform content with yellow-related rubbing, causing other people's sexual desire and low-level interest, including but not limited to:
                        <ol start="(1)" type="(1)">
                        <li>Use the sensitive parts of the body to play games, including but not limited to: guess the color of underwear, guess the color of underwear, cut stockings, live off / wear stockings, tear or cut clothes;</li>
                        <li>Licking the buttocks, showing the crotch, and drawing the circle with the hips;</li>
                        <li>Make movements that are risky, including but not limited to bending, lifting legs, legs apart, splits, lower back, inverted, frequently switching postures, etc.;</li>
                        <li>It is forbidden to perform in a vulgar, teasing manner, such as exposing dress, tempting action, swearing, anger, etc.;</li>
                        <li>It is forbidden to make vulgar sounds, including not limited to rapid breathing, squeaking, sputum, analog mouth-sex, sexual sound effects, etc.;</li>
                        <li>Use direct or implicit suggestive words;</li>
                        <li>Pull up clothes and skirts;</li>
                        <li>Rub chest, hips, and lips;</li>
                        <li>Perform sexually provocative performances or acts, such as striptease performances;</li>
                        <li>Perform sexually provocative forms of performance or behavior with others, such as touching sensitive parts, performing sexual fantasies, performing performances in bed in any form, etc.;</li>
                        <li>Display body-sensitive parts with sexual characteristics in various ways, such as the chest of women, the buttocks of men and women, the inner thighs of the men and women and the reproductive organs, and wearing a see-through;</li>
                        <li>Sing and play music with pornographic and sexual cues;</li>
                        <li>Broadcast games with pornographic, sexually suggestive games, videos, pictures, paintings, and design;</li>
                        <li>Imitate various vulgar, erotic actions or acts of seductive, provocative performance;</li>
                        <li>Deliberately focus on the sensitive part of the lens, or make touch with sexual cues, pull the action, or use the prop to guide the audience to pay attention to the sensitive part;</li>
                        <li>Use sex products as performance props;</li>
                        <li>Use props to imitate vulgar, pornographic, sexually suggestive actions during performances;</li>
                        <li>Deliberately imitating all kinds of voices with sexual provocation;</li>
                        <li>Deliberately publish the rhetoric involving sex guiding the vulgar interaction in the field;</li>
                        <li>It is strictly forbidden to broadcast live on the bed or use the bed as a prop to broadcast live;</li>
    
                        </ol>
                        </li>
                        
                        <li> the broadcaster dress code:
                        <ol start="(1)" type="(1)">
                        <li>Men are prohibited from being naked and women are too exposed such as exposing chest and hips;</li>
                  <li>It is forbidden to wear fishnet stockings, garter socks, low waist shorts, sexy uniforms, sexy lingerie, see-through clothes, flesh-colored tights, underwear, half-breasted bra, triangular shorts or triangular shorts and underwear. Three-pointed navel swimsuit, wearing a tube top and a female hostess, revealing a one-third of the chest;
                  <br>Remarks: The swimming pool can be worn in a swimsuit (but not one-third of the chest)
                  </li>
                  <li>Broadcast in a work-uniform with personnel of the state organs and the army;</li>
                  <li>Clothing with sexually suggestive words or pictures;</li> 
                        </ol>
                        </li>
                        
                        <li> dressing rules:
                        <ol start="(1)" type="(1)">
                        <li>Female broadcaster clothing cannot pass through the dew, nor only wear bikinis and underwear-like clothing or wear underwear, nor reveal underwear or underwear (safety pants)</li>
    <li>The exposed part of the female broadcaster's back should not exceed two-thirds of the upper half, above the waistline.</li>
    <li>The female broadcaster must wear the waist above the pelvis. The lower waist should not be lower than 2cm below the umbilicus. The tibia and pelvis should not be exposed. The skirt or shorts hem should not be higher than the hip line. The male broadcaster shall not be only broadcasted in the costumes of the bottoms or the underwear or tights, and the waistband shall not be lower than the cheekbones;</li>
    <li>The exposed area of ​​the female broadcaster's chest shall not exceed one-third of the chest, and the minimum of the upper body shall not exceed one-third of the chest;</li>
    <li>The shooting angle of the broadcaster should not be taken from the top to the bottom to detect sensitive parts such as the chest, and the sensitive parts such as the legs and hips are photographed from bottom to top;</li>
    <li>The broadcaster must not focus on sensitive parts such as legs and feet for a long time to display or expose tattoos;</li>
    <li>The clothing must not be worn to cause the outline of the lower body to be obvious, and the picture is vulgar;</li> 
                        </ol>
                        </li>
                        
                        <li> Advertising categories, including but not limited to:
                        <ol start="(1)" type="(1)">
                        <li>The broadcaster can only accept, publish, transmit, and disseminate advertisements of regular e-commerce platforms, as well as advertisements by regular APP vendors, game manufacturers, brand manufacturers or other advertisers provided by Mango Live (the aforementioned regular e-commerce) The advertisements of the platform are limited to the advertisement information of related stories in the aforementioned regular e-commerce platform, and the forms of publication, transmission, and dissemination include but not limited to words, sounds, pictures, pictures, two-dimensional codes, website websites, etc.; for the advertisement of the platform, the broadcaster should report in the following manner, otherwise it is a violation advertisement:</li>
                        <li>If the broadcaster undertakes, publishes, transmits or transmits the advertisements of the aforementioned regular e-commerce platform, he/she shall report to the guild where it is located, and send it to the official mailbox of Mango Live by its guild; the broadcaster without a guild can report to Mango Live Official: yinxiaoyan@redefine.global; all should be based on replies by Mango Live Official.</li> 
                        <li>The following categories are available for reporting:
                            <ol start="a" type="a">
                                <li>regular channel category;</li>
                    <li>Jewelry. Such as: buying and selling gold, jade, jewelry, bracelets, necklaces, etc.;</li>
                    <li>E-commerce category. Such as snack shops, daily necessities, clothing, shoes and hats, gaming peripherals, light luxury items (watches, wallets), digital products, etc.;</li>
                    <li>Animals and plants. Such as pets, plant purchasing, etc. (excluding national protected animals, buying and selling wild animals);</li>
                    <li>Apps.</li>
    
                            </ol>
                        </li>
                        </ol>
                        </li>
                        
                        <li> Sector related rules:
                        <ol start="(1)" type="(1)">
                        <li>The broadcaster does not show face live/not makeup;</li>
    <li>The broadcast clothing is smashing/live environment is noisy;</li>
    <li>The broadcaster does not speak for a long time/does not interact with the audience;</li>
    <li>Broadcaster unrelated content such as movies and animations during the live;</li>
    <li>The main broadcaster has no interaction with the audience, and does not reply or ignore the audience's barrage message;</li>
    <li>The main broadcaster of the section is not in live broadcast, and videos such as live video are placed in the live broadcast;</li>
    <li>The broadcaster interacts with the audience with a low attitude, excessive speech, malicious attacks on others, including shackles, shackles, and regional attacks;</li>
                        </ol>
                        </li>
                        
                        <li> Title related specifications, including but not limited to:
                        <ol start="(1)" type="(1)">
                        <li>No relevant content of domestic and foreign leaders can be involved;</li>
    <li>It cannot be involved in military matters, such as sensitive topics such as domestic and foreign military exercises;</li>
    <li>It cannot be related to sensitive topics such as history, national history, and military history;</li>
    <li>No police or law enforcement personnel can be involved;</li>
    <li>No information related to gambling, violence, pornography, vulgarity, marketing, etc.;</li>
    <li>No excessive vulgarity and defamatory statements;</li>
    <li>The title of the live broadcast must have complete live elements. Meaningless symbols and numbers cannot clarify the content.</li>
                        </ol>
                        </li>
                        
                        <li> Title related specifications, including but not limited to:
                        <ol start="(1)" type="(1)">
                        <li>No relevant content of domestic and foreign leaders can be involved;</li>
    <li>It cannot be involved in military matters, such as sensitive topics such as domestic and foreign military exercises;</li>
    <li>It cannot be related to sensitive topics such as history, national history, and military history;</li>
    <li>No police or law enforcement personnel can be involved;</li>
    <li>No information related to gambling, violence, pornography, vulgarity, marketing, etc.;</li>
    <li>No excessive vulgarity and defamatory statements;</li>
    <li>The title of the live broadcast must have complete live elements. Meaningless symbols and numbers cannot clarify the content.</li>
                        </ol>
                        </li>
                        
                    </ol>
                    </li>
                    
                    <li>the Classification of Punishment Measures:
                    <ol start="1" type="1">
                    <li>
                     If the broadcaster has a violation, once it is determined, it will be punished according to the seriousness of the situation:
                        <br>Serious violations (Class A violations)
                        <br>General violations (Class B violations)
                        <br>Minor violations (C violations)
                        </li>
                        <li> Violation rules:
                        <ol start="(1)" type="(1)">
                        <li>Class A punishment: immediately stop the right to broadcast, restrict the mobile phone number to broadcast, and reserve the right to transfer to the judicial organs;</li>
    <li>Class B punishment: according to the situation and the number of violations, warn, remove, and restrict live broadcast functions, etc.; if the circumstances are serious, the live broadcast room will be permanently closed;</li>
    <li>Class C punishment: remove broadcaster room;</li>
                        </ol>
                        </li>
                    </ol>
                    </li>
                    <li>Penalty rules:
                    <ol>
                        <li>
                            <table border="0" cellspacing="0" cellpadding="0">
                                <tbody><tr>
                                    <td>Times/Month</td>
    <td>No Limits</td>
    <td>2</td>
    <td>3</td>
    <td>4</td>
    <td>5</td>
    
    
                                </tr>
                                <tr>
                                <td>Punishment</td>
    <td>Warning</td>
    <td>Close for 1 day</td>
    <td>Close for 7 days</td>
    <td>Close for 30 days</td>
    <td>Close permanently</td>
    
    
                                </tr>
                            </tbody></table>
                        </li>
                        <li>The corresponding number of violations of Class B violations is enforced:</li>
                        <li>
                            <table border="0" cellspacing="0" cellpadding="0">
                                <tbody><tr>
                                    <td>Times/Month</td>
    <td>No Limits</td>
    
    
                                </tr>
                                <tr>
                                <td>Punishment</td>
    <td>Warning to remove and optimize live rooms</td>
    
    
                                </tr>
                            </tbody></table>
                        </li>
                        <li>Remarks:
                        <ol start="1" type="1">
                        <li>As for broadcaster involving audience-fraud, Mango Live will cooperate with the police to recover the money and pursue legal responsibility.</li>
    <li>The Regulation will be updated on an irregular basis. Please be strict with the Regulation, and do not hold the lucky state of mind to catchwords. The Regulation includes but not limited to the contents disclosed in the above! The scope of the investigation includes but not limited to: nickname, title, background template text, graphic dynamics, video, etc.</li>
    <li>According to the platform situation, the penalty content will update to deduct certain gift settlements and reduce promotion efforts. If the broadcaster does not change after communication, their live rooms will be permanently closed. If they violate national laws, the right to pursue responsibility will be retained. This platform has the final interpretation of the above rules.</li>
    
                        </ol>
                        </li>
                        
                        
                    </ol>
                    </li>
                    </ol>
                
                
                <br>
            </font>				</div>
    
        </div>
         <!-- <Footer></Footer> -->
    </div>  
</template>
<script>
export default {

    data(){
        return{
          isuser:true
        }
    },
     created(){

    },
    methods:{

    },
}
</script>
<style lang="less" scoped>

@media screen and (min-width: 1000px) {
  .joinbox{
       background:#fff;
       font-size: .09rem;line-height:0.17rem
  }
  .boxminiright {
    width: 90%;
    padding-left: 20px;
    height: auto;
    margin-top: 40px;
    margin-bottom: 40px;
    float: left;
}
ol {
    display: block;
    list-style-type: decimal;
    margin-block-start: 1em;
    margin-block-end: 1em;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
    padding-inline-start: 40px;
}
ol ol {
    margin-block-start: 0px;
    margin-block-end: 0px; margin-top: .1rem;
}
    .logobtns{
      width: 100%; height: .42rem; display: flex; 
       box-sizing: border-box;
      justify-content: space-between; align-items: center;
     .logo{
         width:1.04rem; height: .2rem;
        background:  url('../../assets/images/liveimg/LOGO_phone@2x.png');
        background-size: 100% 100%;
     } 
  }
}
@media screen and (max-width:900px){
  .joinbox{
       background:#fff;
       font-size: .3rem;line-height:0.45rem
  }
  .banxin{
    width: 80%;
  }
  .boxminiright {
    width: 100%;
    padding-left: 20px;
    height: auto;
    margin-top: 40px;
    margin-bottom: 40px;
    float: left;
}
ol {
    display: block;
    list-style-type: decimal;
    margin-block-start: 1em;
    margin-block-end: 1em;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
    padding-inline-start: 40px;
}
ol ol {
    margin-block-start: 0px;
    margin-block-end: 0px; margin-top: .3rem;
}
    .logobtns{
      width: 100%; height: .8rem; display: flex; 
       box-sizing: border-box;
      justify-content: space-between; align-items: center;
     .logo{
         width:3.46rem; height: .6rem;
        background:  url('../../assets/images/liveimg/LOGO_phone@2x.png');
        background-size: 100% 100%;
     } 
  }
}

 table {
    width: 100%;
    min-height: 25px;
    line-height: 25px;
    text-align: center;
    border-collapse: collapse;
    padding: 2Px;
}
table, table tr th, table tr td {
    border: 1Px solid #ccc;
}
</style>


// WEBPACK FOOTER //
// src/page/webpage/broadcasters.vue